import React from 'react';
import { Helmet } from 'react-helmet';
import { Beaker, FlaskConical, Lightbulb, Settings } from 'lucide-react';
import GlobalNavbar from '@/components/GlobalNavbar';
import Footer from '@/components/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import LanguageHreflang from '@/components/LanguageHreflang';
import { useTranslation } from '@/hooks/useTranslation';
import '@/styles/provatio-unified-design.css';

const LabsPage = () => {
  const { t } = useTranslation();

  usePageMeta({
    title: t('labs.titulo'),
    description: t('labs.descricao'),
  });

  return (
    <div className="min-h-screen flex flex-col provatio-unified">
      <Helmet>
        <title>{t('labs.titulo')} - PROVATIO</title>
      </Helmet>
      <LanguageHreflang />
      
      <GlobalNavbar />

      <section className="bg-[#193D6D] text-white text-center py-24 px-6 relative bg-gradient-to-b from-[#193D6D] to-[#112739]">
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="flex justify-center mb-6">
            <Beaker className="w-16 h-16 text-[#D4AF37]" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight text-[#D4AF37]">
            {t('labs.titulo')}
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            {t('labs.descricao')}
          </p>
        </div>
      </section>

      <div className="h-2 w-full bg-[#D4AF37]"></div>

      <main className="flex-1 container mx-auto max-w-7xl py-16 px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="pv-card p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-[#193D6D]/10 flex items-center justify-center mb-6">
              <FlaskConical className="w-8 h-8 text-[#193D6D]" />
            </div>
            <h3 className="text-xl font-bold text-[#193D6D] mb-3">Pesquisa Forense</h3>
            <p className="text-gray-600">Desenvolvimento de novas ferramentas e algoritmos para análise pericial avançada.</p>
          </div>
          <div className="pv-card p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-[#193D6D]/10 flex items-center justify-center mb-6">
              <Lightbulb className="w-8 h-8 text-[#193D6D]" />
            </div>
            <h3 className="text-xl font-bold text-[#193D6D] mb-3">Inovação em IA</h3>
            <p className="text-gray-600">Modelos de linguagem treinados especificamente para o contexto jurídico e pericial.</p>
          </div>
          <div className="pv-card p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-[#193D6D]/10 flex items-center justify-center mb-6">
              <Settings className="w-8 h-8 text-[#193D6D]" />
            </div>
            <h3 className="text-xl font-bold text-[#193D6D] mb-3">Ferramentas Beta</h3>
            <p className="text-gray-600">Acesso antecipado a recursos experimentais em fase de testes e validação.</p>
          </div>
        </div>

        <div className="pv-card p-12 text-center bg-[#F9FAFB] border-dashed">
          <h3 className="text-2xl font-bold mb-4 text-[#193D6D]">{t('labs.status')}</h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('labs.statusDesc')}</p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LabsPage;